import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6ac39145"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=6ac39145&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac39145')) {
      api.createRecord('6ac39145', component.options)
    } else {
      api.reload('6ac39145', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=6ac39145", function () {
      api.rerender('6ac39145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/settings/Settings.vue"
export default component.exports